/* tslint:disable */
/* eslint-disable */
/**
 * API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../../common/runtime';
import type { Lead } from './Lead';
import { LeadFromJSON, LeadFromJSONTyped, LeadToJSON } from './Lead';
import type { DpCall } from './DpCall';
import { DpCallFromJSON, DpCallFromJSONTyped, DpCallToJSON } from './DpCall';
import type { LeadListItem } from './LeadListItem';
import {
  LeadListItemFromJSON,
  LeadListItemFromJSONTyped,
  LeadListItemToJSON,
} from './LeadListItem';

/**
 *
 * @export
 * @interface LeadItem1
 */
export interface LeadItem1 {
  /**
   *
   * @type {LeadListItem}
   * @memberof LeadItem1
   */
  item: LeadListItem;
  /**
   * the LeadListItem id
   * @type {string}
   * @memberof LeadItem1
   */
  itemId: string;
  /**
   *
   * @type {DpCall}
   * @memberof LeadItem1
   */
  lastCall: DpCall;
  /**
   *
   * @type {Lead}
   * @memberof LeadItem1
   */
  lead: Lead;
}

/**
 * Check if a given object implements the LeadItem1 interface.
 */
export function instanceOfLeadItem1(value: object): value is LeadItem1 {
  if (!('item' in value) || value['item'] === undefined) return false;
  if (!('itemId' in value) || value['itemId'] === undefined) return false;
  if (!('lastCall' in value) || value['lastCall'] === undefined) return false;
  if (!('lead' in value) || value['lead'] === undefined) return false;
  return true;
}

export function LeadItem1FromJSON(json: any): LeadItem1 {
  return LeadItem1FromJSONTyped(json, false);
}

export function LeadItem1FromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): LeadItem1 {
  if (json == null) {
    return json;
  }
  return {
    item: LeadListItemFromJSON(json['item']),
    itemId: json['item_id'],
    lastCall: DpCallFromJSON(json['last_call']),
    lead: LeadFromJSON(json['lead']),
  };
}

export function LeadItem1ToJSON(value?: LeadItem1 | null): any {
  if (value == null) {
    return value;
  }
  return {
    item: LeadListItemToJSON(value['item']),
    item_id: value['itemId'],
    last_call: DpCallToJSON(value['lastCall']),
    lead: LeadToJSON(value['lead']),
  };
}
